import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  invoiceTallyDetailsList: { loading: false, data: null, error: null },
};

export const invoiceTallyDetailsSlice = createSlice({
  name: "invoiceTallyDetails",
  initialState,
  reducers: {
    fetchInvoiceTallyDetailsListRequest: (state, action) => {
      state.invoiceTallyDetailsList.loading = true;
      state.invoiceTallyDetailsList.error = null;
    },
    fetchInvoiceTallyDetailsListSuccess: (state, action) => {
      state.invoiceTallyDetailsList.data = action.payload;
      state.invoiceTallyDetailsList.loading = false;
      state.invoiceTallyDetailsList.error = null;
    },
    fetchInvoiceTallyDetailsListFailure: (state, action) => {
      state.invoiceTallyDetailsList.data = null;
      state.invoiceTallyDetailsList.loading = false;
      state.invoiceTallyDetailsList.error = action.payload;
    },
  },
});

export const {
  fetchInvoiceTallyDetailsListRequest,
  fetchInvoiceTallyDetailsListSuccess,
  fetchInvoiceTallyDetailsListFailure,
} = invoiceTallyDetailsSlice.actions;

export const getInvoiceTallyDetailsListState = (store) =>
  store.invoiceTallyDetails?.invoiceTallyDetailsList;

export default invoiceTallyDetailsSlice.reducer;
